import React from "react";
import Container from "./Container";

interface SectionProps {
    children: React.ReactNode;
    className?: string;
    id?: string;
    containerClassName?: string;
}

export default function Section({ children, className = "", id, containerClassName = "" }: SectionProps) {
    return (
        <section id={id} className={`py-24 md:py-32 ${className}`}>
            <Container className={containerClassName}>
                {children}
            </Container>
        </section>
    );
}
